<template>
    <div class="table-item item--collaborate">
      <div class="item">
        <collaborate-label :instance="item"/>
      </div>
    </div>
  </template>
    
    <script>
  import CollaborateLabel from "../../labels/CollaborateLabel.vue";
  export default {
    components: { CollaborateLabel },
    props: {
      item: {
        type: Object,
      },
    },
  };
  </script>